import { MensagemErroModel } from './../../../../shared/model/mensagem-erro.model';

export class DadosOnInitModelView{
  ListaMunicipio: Municipio[];
  objetoMensagem: MensagemErroModel;
}

export class SaldoDevedorMunicipioFiltro{
  DataInicio: Date ;
  DataFim: Date;
  IdMunicipio: string;
  DescricaoMunicipio: string;
}

export class SaldoDevedorMunicipio{
  DataInclusao: Date;
  DescricaoMunicipio: string;
  ValorDevido: string;
}

export class Municipio{
  Descricao: string;
  IdMunicipio: string;
  SigUnidadeFederacao: string;
}

export class SaldoDevedorMunicipioModelView{
  ListaSaldoDevedorMunicipio: SaldoDevedorMunicipio[];
  objetoMensagem: MensagemErroModel;
}


// WEBPACK FOOTER //
// ./src/app/consulta/saldo-devedor-municipio/shared/model/saldoDevedorMunicipio.model.ts